module.exports = __webpack_public_path__ + "static/media/UHOH.a1e817ec.svg";